import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { IAppRoute } from 'interfaces/route';
import React, { createRef, memo, useState } from 'react';

import AppDrawer, { DrawerContext } from '../Drawer';

interface IProps {
  routes: IAppRoute[];
  children?: any;
}

export const ScrollTopContext = React.createContext<Function>((() => { }));

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    width: '100vw',
    height: '100vh'
  },
  drawer: {
    width: theme.variables.drawerWidth,
    borderRight: 'none !important',
    boxShadow: `${theme.variables.boxShadow} !important`,
    backgroundColor: theme.palette.background.default,
    [theme.breakpoints.up('md')]: {
      width: theme.variables.drawerWidth,
      position: 'relative',
      height: '100vh'
    }
  },
  content: {
    width: '100vw',
    height: '100vh',
    overflow: 'auto',
    padding: theme.variables.contentPadding,
    [theme.breakpoints.up('sm')]: {
      padding: theme.variables.contentPaddingUpSm,
    }
  }
}));

const AppWrapper = (props: IProps) => {
  const { children, routes } = props;
  const classes = useStyles();
  const [drawerOpened, setDrawerOpened] = useState(false);
  const mainContent = createRef<HTMLDivElement>();
  const items = <AppDrawer routes={routes} />;

  const scrollTop = () => {
    setTimeout(() => mainContent.current && mainContent.current.scrollTo(0, 0), 100);
  };

  const openDrawer = () => {
    setDrawerOpened(true);
  };

  const closeDrawer = () => {
    setDrawerOpened(false);
  };

  return (
    <div className={classes.root}>
      <DrawerContext.Provider value={{ open: openDrawer, close: closeDrawer }}>
        <Hidden mdUp implementation='css'>
          <Drawer
            variant='temporary'
            anchor='left'
            open={drawerOpened}
            classes={{ paper: classes.drawer }}
            ModalProps={{ keepMounted: true }}
            onClose={closeDrawer}
          >
            {items}
          </Drawer>
        </Hidden>
        <Hidden smDown implementation='css'>
          <Drawer
            variant='permanent'
            classes={{ paper: classes.drawer }}
            ModalProps={{ keepMounted: true }}
            open
          >
            {items}
          </Drawer>
        </Hidden>
        <ScrollTopContext.Provider value={scrollTop}>
          <main ref={mainContent} className={classes.content}>
            {children}
          </main>
        </ScrollTopContext.Provider>
      </DrawerContext.Provider>
    </div>
  );
};

export default memo<IProps>(AppWrapper);